import { Validator } from '@vista-digital/validator';
/**
 * Default configuration options for the Order Totals component.
 */
export const defaultOrderTotalsConfig = {
    showBookingFee: true,
    showEstimatedTaxLabel: false
};
export const orderTotalsConfigValidatorSchema = {
    showBookingFee: Validator.boolean(),
    showEstimatedTaxLabel: Validator.boolean()
};
export const orderTotalsConfigValidator = Validator.object(orderTotalsConfigValidatorSchema);
